module.exports = __webpack_public_path__ + "img/pay_size10.53d2c226.png";